
export class PermissionTypeDto {
    constructor(id :number, name :string) {
        this.permissionId = id;
        this.permissionName = name;
    }

    public permissionId: number;
    public permissionName: string;
}

export class UnitDto {
    unitId: string;
    name: string;
}
export class UserPermissionDto {
    carehomeId: string;
    unitId: string;
    permissionId: number;
    unit: UnitDto;
}
export class UserDto {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    number: string;

    userPermissions: Array<UserPermissionDto>;
}

export class WardCycleDto {
    startDate: Date;
    endDate: Date;
}

export class PatientOrderItemDto {
    vpid: string;
    apid: string;
    drugName: string;
    patientOrderItemContinuityStatus: number;
    notes: string;
    startDate: Date;
    endDate: Date;
    dosageInstruction: string;
    quantity: number;
    carehomePatientOrderItemStatus: number;
    dispensationItemId: string;

    id: string;
    patientId: string;
    pharamcyPatientId: string;
}

export class MedProfileDto {

    dispensationItemId: string;
    drugName: string;
    dosageInstruction: string;
    drugImageId: string;
    dosageType: string;
    medRounds: Array<MedRoundDto>;

    sent : number;
    received : number;
    broughtForward: number;
    broughtForwardUserOverride: boolean;
    expectedBroughtForward: number;

    total : number;
    taken : number;
    returned : number;
    destroyed : number;
    carryForward: number;

    checkedIn: boolean;
    
    checkedInUser: string;
    medicineReturnedUser: string;

    deliverySignTimeStamp: Date;
    returnSignTimeStamp: Date;

    whenUpdated : Date;
    whenCreated : Date;
}

export class DispensationRoundItem {
    roundTime: string;
    colourHex: string;
    roundTimeStatus: number;
    id: string;
}

export class MedRoundGroup {
    medRoundGroupName: string;
    medRoundGroupStartTime: string;
    medRoundGroupEndTime: string;
    medRoundGroupStatus: number;
    //medRoundList: Array<DispensationRoundItem>;

    takenCount    : number;
    skipCount     : number;
    pendingCount  : number;
    missedCount: number;
}


export class EMARResult {
    latestMARUser: string;
    latestMedAdminDateTime: Date;
    roundGroups: Array<MedRoundGroup>;
    //insulin: Array<object>;
    //prn: Array<object>;
    //warfarinGroupStatus: number;
}


export class PatientDispensationStatus {
    id: string;
    carer: string;
    marDate: Date;
}

export class CarehomeDispensationStatus {
    lastUpdateTime: number;
    patients: Array<PatientDispensationStatus>;
}


//export class MedRoundDto {

//    constructor() {
//        this._ColourHex = "";
//        this.colourHex = "";
//    }
//    displayTextRound: string;
//    _colourHex: string;
//    roundTime: string;
//    dosage: string;

//    public set _ColourHex(val: string) {
//        this._colourHex = val;
//    }
//    public get _ColourHex(): string {
//        return this._colourHex;
//    }
//    public set colourHex(val: string) {
//        this._colourHex = val;
//    }
//    public get colourHex(): string {
//        return this._colourHex;
//    }
//}


export class MedRoundDto {

    constructor() {
        //this._ColourHex = "";
        //this.colourHex = "";
    }
    displayTextRound: string;
    colourHex: string;
    roundTime: string;
    dosage: string;

    //public set _ColourHex(val: string) {
    //    this._colourHex = val;
    //}
    //public get _ColourHex(): string {
    //    return this._colourHex;
    //}
    //public set colourHex(val: string) {
    //    this._colourHex = val;
    //}
    //public get colourHex(): string {
    //    return this._colourHex;
    //}
}


export class DispensationItemDto {

    patientId: string;
    patientOrderItemId: string;
    pharamcyPatientId: string;
    id: string;
    createdFromPatientOrder: boolean;
    customDrugId: string;
    defaultedFromPrevCycleDispensation: boolean;
    dispensationStatus: number;
    dispensationDateTime: Date;
    whenCreated: Date;
    whenUpdated: Date;
    whoUpdated: string;

    //Control Fields
    isRemoved: boolean;
    pharmacyDispensed: boolean;
    
    // Drug Selector
    // BrandedDrugId
    apid: string;
    vpid: string;
    drugName: string;


    // Days Control
    daysOfDosagePattern: string;
    // Round Control
    medRounds: Array<MedRoundDto>;

    dosageChanged: boolean;
    // Text Field
    dosageInstruction: string;
    notes: string;
    quantity: number;
    unitOfMeasure: string;

    startDate: Date;
    endDate: Date;

    //Checkboxes
    isInsulin: boolean;
    showInEMAR: boolean; // Only editable field if Pharmacy Dispsensed Medicine
    treatAsCD: boolean;
    useBodyMap: boolean;



    // Do not remove initializers or VUE does not bind
    constructor() {
        this.dosageInstruction = ""
        this.notes = ""
        this.quantity = 0;
        this.unitOfMeasure = ""
        this.isInsulin = false;
        this.showInEMAR = false;
        this.treatAsCD = false;
        this.useBodyMap = false;
        this.unitOfMeasure = "";
    }


}



// WEBPACK FOOTER //
// ./ClientApp/dto/Dtos.ts